enum EntityType {
  MOVIE = 1,
  TV = 2,
  PERSON = 3,
  REVIEW = 4,
  COMPANY = 5,
  COLLECTION = 6,
  KEYWORD = 7,
}

export default EntityType;
